import { approximatedValue } from '../../../../../../utils'
import React from 'react'
import { FormattedNumber } from 'react-intl'
import { Typography } from '@lightbeamai/design-system'
import classNames from 'classnames'
import { CaretRight } from 'phosphor-react'
import { useHistory } from 'react-router-dom'

interface IProps {
  label: string
  count: number
  link?: string
  className?: string
  isApproximated?: boolean
}
export const LabelItem = ({
  label,
  count,
  link,
  className = '',
  isApproximated = false
}: IProps) => {
  const history = useHistory()
  const handleClick = () => {
    if (link) {
      history.push(link)
    }
  }

  return (
    <div
      className={classNames('label-item', { 'with-link': link }, { [className]: className })}
      onClick={handleClick}
    >
      <Typography color="primary" type="strong" variant="h4">
        <FormattedNumber value={count || 0} notation="compact">
          {isApproximated ? approximatedValue : undefined}
        </FormattedNumber>
      </Typography>
      <Typography className="ac-label-text" color="secondary" type="medium" variant="baseMinus2">
        {label}
        <CaretRight />
      </Typography>
    </div>
  )
}
